import { TryFirstButtonUiTheme } from "@redotech/redo-model/team";
import { TnplContractTemplateInAutoCheck } from "@redotech/redo-model/tnpl-contract-template";
import { getEvaluatedTryFirstButtonSettings } from "@redotech/redo-storefront-common/config/try-first-button-config";
import { RedoButton } from "@redotech/redo-web/arbiter-components/buttons/redo-button";
import { memo } from "react";
import Info from "../info.svg";
import * as styles from "./button-ui.module.css";

type TryFirstButtonUiProps = {
  theme: TryFirstButtonUiTheme;
  isLoading: boolean;
  infoModal: boolean;
  onInfoClick: (
    e: React.MouseEvent<HTMLButtonElement>,
  ) => any | (() => Promise<any>);
  handleTryFirstClick: (
    e: React.MouseEvent<HTMLButtonElement>,
  ) => any | (() => Promise<any>);
  contractTemplate: TnplContractTemplateInAutoCheck;
};

export const TryFirstButtonUi = memo(function TryFirstButtonUi({
  theme,
  onInfoClick,
  isLoading,
  handleTryFirstClick,
  infoModal,
  contractTemplate,
}: TryFirstButtonUiProps) {
  const evaluatedTheme = getEvaluatedTryFirstButtonSettings({
    settingsTemplate: theme,
    contractTemplate,
  });

  return (
    <div
      className={styles.tryFirstButtonContainer}
      data-target="try-first-button-container"
    >
      <style
        dangerouslySetInnerHTML={{ __html: genTryFirstCss(evaluatedTheme) }}
      />
      <div
        className={styles.tryFirstButtonAndText}
        data-target="try-first-button-and-text"
      >
        <RedoButton
          buttonClassName={styles.tryFirstButton}
          data-target="try-first-button"
          disabled={isLoading}
          hierarchy="secondary"
          onClick={handleTryFirstClick}
          pending={isLoading}
          size="md"
          text={evaluatedTheme.text}
          theme="normal"
        />
        <div
          className={styles.tryFirstDisclaimer}
          data-target="try-first-disclaimer"
        >
          {evaluatedTheme.subtext}
          {infoModal && (
            <button
              className={styles.info}
              data-target="try-first-info-button"
              onClick={onInfoClick}
              style={{ marginLeft: "4px" }}
              type="button"
            >
              <Info className={styles.infoIcon} />
            </button>
          )}
        </div>
      </div>
    </div>
  );
});

const genTryFirstCss = (
  theme: ReturnType<typeof getEvaluatedTryFirstButtonSettings>,
) => {
  return `
    /* Try First Button Container */
    [data-target="try-first-button-container"] {
    }
    
    /* Try First Button itself */
    [data-target="try-first-button"] {
      background-color: ${theme.bgColor} !important;
      border-color: ${theme.borderColor} !important;
      color: ${theme.textColor} !important;
    }
    
    [data-target="try-first-button"]:hover {
      opacity: 0.9;
    }
    
    /* Button and text container */
    [data-target="try-first-button-and-text"] {
    }
    
    /* Disclaimer/subtext styling */
    [data-target="try-first-disclaimer"] {
      color: ${theme.subtextColor} !important;
      font-size: ${theme.subtextFontSize} !important;
    }
    
    /* Info button styling */
    [data-target="try-first-info-button"] {
    }
  `;
};
